import Checkmark from "@/common/icons/checkmark"

export default function CheckmarkCircle({ selected = false, className = "" }) {
  const selectedClasses = "bg-good-green-50 text-black border-good-green-50"

  return (
    <span
      className={[
        "checkmark-circle inline-flex h-5 w-5 mr-3 rounded-full border border-black-100/25 items-center justify-center group-hover:bg-good-green-100 group-hover:border-good-green-100 flex-shrink-0",
        selected ? selectedClasses : "",
        className
      ].join(" ")}>
      {selected && <Checkmark className="w-2 h-2" />}
    </span>
  )
}
